import React, { Component } from 'react';
import UiKit                                from '../../../uikit';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    
    render() {
        let { title, onClose } = this.props;
        return (
            <div className="simprakit-modal-header">
                <span className="simprakit-modal-header-title">{ title }</span>
                <i 
                    className = 'fas fa-times t20 simprakit-modal-close-icon'
                    onClick   = { () => onClose() }
                />
            </div>
        )
    }
}

export default Header;